/**
 * /app/trusts/$id/settings — Trust settings + DSAR (route shell).
 *
 * Screen impl in `./settings-screen.tsx`, lazy-loaded via `lazyRouteComponent`.
 * A deep trust sub-tab (read-only trust fields + data-subject-request flow), not
 * a first-paint route, so the body leaves the entry bundle (200 kB gzip budget).
 * Same shell+screen pattern as the sibling `./documents.tsx` / `./audit.tsx`
 * tabs. The committed routeTree.gen.ts imports only `Route` from here, so no
 * plugin regen is needed.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/settings')({
  component: lazyRouteComponent(() => import('./settings-screen'), 'TrustSettingsScreen'),
});
